import classNames from 'classnames'
import React, { useContext } from 'react'

import BackButton from '@/components/back-button/back-button'
import TextElement from '@/components/text-element/text-element'
import { ColorContext } from '@/contexts/color.context'

import * as style from './header.module.scss'

type HeaderListProps = {
  title?: string | null
  titleIsUppercase?: boolean
  subtitle?: string | null
  description?: string | null
  parent?: {
    readonly slug: string | null
    readonly internalName: string | null
  } | null
}

const HeaderList: React.FC<HeaderListProps> = ({
  title,
  titleIsUppercase = false,
  subtitle,
  description,
  parent
}) => {
  const colour = useContext(ColorContext)
  const headerStyle = colour?.colour?.hex
    ? { backgroundColor: colour?.colour?.hex }
    : {}
  const titleClassName = titleIsUppercase
    ? `${style.title} ${style.uppercase}`
    : style.title

  const lightColor = colour?.isLight === true ? style.darkText : ''

  return (
    <div className={classNames(style.header, lightColor)} style={headerStyle}>
      <div className="container">
        <div className="row">
          {parent && (
            <BackButton
              url={`/${parent.slug}`}
              label={parent.internalName!}
              className={classNames(style.backButton, lightColor)}
            />
          )}
          <div className="col pt-2">
            <TextElement text={title!} type="h1" className={titleClassName} />
          </div>
        </div>
        {subtitle && (
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <TextElement
                text={subtitle}
                type="h2"
                className={style.subtitle}
              />
            </div>
          </div>
        )}
        {description && (
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <TextElement
                text={description}
                type="p"
                className={style.description}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default HeaderList
